// import { BaseQueryApi } from "@reduxjs/toolkit/dist/query/react";
import { StorageKeys } from "constants/storageKeys";
import { getStorage } from "utils/StorageHelper";

export function prepareHeaders(
  headers: Headers
  // api: Pick<BaseQueryApi, "getState" | "extra" | "endpoint" | "type" | "forced">
) {
  const token = getStorage(StorageKeys.token);

  if (token) {
    headers.set("authorization", `Bearer ${token}`);
  }

  return headers;
}
